'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSparkleSwirls, iconSparkleSwirlsTag } from '@ni/nimble-components/dist/esm/icons/sparkle-swirls';
import { wrap } from '../../utilities/react-wrapper';

export type { IconSparkleSwirls };
export { iconSparkleSwirlsTag };
export const NimbleIconSparkleSwirls = wrap(IconSparkleSwirls);